<template>
    <div>
        <input type="text"  autocomplete="off" class="layui-input" readonly="readonly"/>
        <i class="layui-icon layui-icon-date" style="position: absolute;top:8px;right: 8px;margin-top: 0px;"></i>
    </div>
</template>

<script>
// 该组件暂时不支持v-model,不建议用在form表单中，一般用于查询表单中
export default {
    name: 'LayuiDatetimerange',
     _model: {
        default: '',
        required: false
    },
    props: {
        placeholder: {
            default: '',
            type: String
        },
         _model: {
            default: '',
            required: false
        },
        isDefaultVal:{
             default: false,
             type: Boolean
        }
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data: function(){
        return {
        }
     },
     mounted(){
        var id = this.id = 'layuidaterange' + this.uuid();
        var element = this.el = $(this.$el);
        if(this.placeholder) {
            element.find('input').attr('placeholder', this.placeholder);
        }
        element.find('input').attr('id', this.id);
        //let defaultValue = new Date().toLocaleDateString().split('/').join('-')+' 00:00:00 - '+new Date().toLocaleDateString().split('/').join('-')+' 23:00:00';
        this.layui.laydate.render({
            elem: '#' + this.id,
            type: 'datetime',
            range: true,
            done: (value, date) => {
                this.$emit('_modelEvent', value);
                this.$emit('dateChange', value);
            },
        });
    },
    methods: {
        select(value) {
            $('#' + this.el.find('input').attr('id')).val(value);
        },
        reset() {
             $('#' + this.el.find('input').attr('id')).val('');
        },
        
    },
    watch:{
         _model(value){
           this.select(value);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiDatetimerange.vue